const Types = {
  getters: {},
  mutations: {
    SET_USER_TOKEN: 'SET_USER_TOKEN',
    SET_AUTH_RESET: 'SET_AUTH_RESET',
    SET_EXPIRES_IN: 'SET_EXPIRES_IN',
    SET_GCE_USER_TOKEN: 'SET_GCE_USER_TOKEN',
    SET_GCE_AUTH_RESET: 'SET_GCE_AUTH_RESET',
    SET_GCE_EXPIRES_IN: 'SET_GCE_EXPIRES_IN',
    RESTORE_GCE_TOKEN: 'RESTORE_GCE_TOKEN'
  },

  actions: {
    UPDATE_USER_TOKEN: 'UPDATE_USER_TOKEN',
    UPDATE_GCE_USER_TOKEN: 'UPDATE_GCE_USER_TOKEN',
    UPDATE_GCE_EXPIRES_IN: 'UPDATE_GCE_EXPIRES_IN',
    UPDATE_AUTH_RESET: 'UPDATE_AUTH_RESET',
    UPDATE_GCE_AUTH_RESET: 'UPDATE_GCE_AUTH_RESET',
    UPDATE_EXPIRES_IN: 'UPDATE_EXPIRES_IN'
  },
  localdb: {
    GCE_USER_TOKEN: 'GCE_USER_TOKEN',
    GCE_EXPIRES_IN: 'GCE_EXPIRES_IN',
    GCE_USER: 'GCE_USER',
    USER_TOKEN: 'TOKEN',
    EXPIRES_IN: 'EXPIRES_IN',
    USER_ROLE: 'USER_ROLE',
    USER: 'USER'
  }
}
export default Types
